import { AskAiCommand, CustomCommand } from './types';
import {
  beforeAskAiCommandStart,
  getAiCommandActionHandler,
} from './utils/action-handler';
import { getPositionSelectedByUserIfAny } from './utils/expand-to-sentence';
import { getSelectionAsJSON } from '../../../utils/editor-utils';
import { setSelection } from '../../../utils/selection';
import { addAskAiSelectionHighlight } from '../../aski-ai-selection-highlight/utils';
import { expandSelectionPositionToIncludeEntireSentence } from '../utils/expand-selection-to-sentence';

export const makeLongerCommand: CustomCommand = ({
  editor,
  dispatch,
  tr,
  options,
}) => {
  if (!dispatch) {
    return false;
  }
  const {
    from: initialFrom,
    to: initialTo,
    noTextSelected,
  } = getPositionSelectedByUserIfAny(editor);

  const { from: updatedFromPosition, to: updatedToPosition } =
    expandSelectionPositionToIncludeEntireSentence(
      editor,
      initialFrom,
      initialTo,
    );
  const selectedContent = getSelectionAsJSON(
    editor,
    updatedFromPosition,
    updatedToPosition,
  );

  beforeAskAiCommandStart(editor, AskAiCommand.MakeLonger);
  if (!noTextSelected) {
    setSelection(tr, initialTo, initialTo);
    addAskAiSelectionHighlight(
      editor,
      tr,
      updatedFromPosition,
      updatedToPosition,
    );
  }
  const { onCancel, onComplete } = getAiCommandActionHandler(
    AskAiCommand.MakeLonger,
    editor,
    { from: initialFrom, to: initialTo },
    { from: updatedFromPosition, to: updatedToPosition },
    options,
  );

  options.processAskAiRequest({
    payload: {
      command: AskAiCommand.MakeLonger,
      content: selectedContent,
      selection: { from: updatedFromPosition, to: updatedToPosition },
    },
    editor,
    onCancel: onCancel,
    onComplete: onComplete,
  });

  return true;
};
